<template>
  <div>
    <div class="gSwiperBox-banner">
      <swiper :options="swiperOption" ref="mySwiper-banner" v-if="list && list.length > 0">
        <swiper-slide v-for="(item,index) in list" :key="index">
          <a :href="item.url" v-if="item.url" target="_blank">
            <img v-if="item.imgUrl" :src="item.imgUrl" />
          </a>
          <div v-else>
            <img v-if="item.imgUrl" :src="item.imgUrl" />
          </div>
          <!-- <h1>始创于1979年，每年举办春秋两届，包括展览和论坛两个部分</h1>
            <a class="banner-btn" v-if="item.url" :href="item.url">查看详情</a> -->
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="swiper-button-prev">
        <i class="icon iconfont icon-xiangshang"></i>
      </div>
      <div class="swiper-button-next">
        <i class="icon iconfont icon-xiangshang"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "gSwiper",
  data () {
    return {
      // swiperOption: {
      //   // some swiper options/callbacks
      //   // 所有的参数同 swiper 官方 api 参数
      //   // ...
      //   spaceBetween: 0,
      //   loop: true,
      //   autoplay: true,
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   }
      // },
      list: []
    };
  },
  computed: {
    swiperOption () {
      let that = this;
      let opt = {
        spaceBetween: 0,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        observer: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
        // grabCursor: true,
        // paginationClickable: true,
        // onSlideClick: function(swiper) {
        //   const s = swiper.clickedSlide.attributes["data-href"];
        //   const Datafrom = swiper.clickedSlide.attributes["data-Datafrom"];
        //   if (Datafrom && Datafrom.nodeValue) {
        //     that.setSourse(Datafrom.nodeValue);
        //     that.setShowHostModal(true);
        //   }
        //   if (s && /(http|https):\/\/([\w.]+\/?)\S*/.test(s.nodeValue)) {
        //     window.open(s.nodeValue);
        //   }
        // }
      };
      return opt;
    },
    swiper () {
      return this.$refs.mySwiper - banner.swiper;
    }
  },
  mounted () {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //   this.swiper.slideTo(3, 1000, false);
  },
  methods: {
    ...mapActions({
      getBanner: "home/getBanner"
    }),
    async getHomeBanner () {
      let res = await this.getBanner();
      let arr = [];
      if (res && res.length) {
        res.map(c => {
          if (c.typeId === 1) {
            arr.push(c);
          }
        })
      }
      this.list = arr;
    },
  },
  created () {
    this.getHomeBanner();
  }
};
</script>

<style lang="scss">
@media (min-width: 799px) {
.swiper-slide {
  img {
    width: 100%;
  }
}
.gSwiperBox-banner {
  position: relative;
  min-width: 1200px;
  &:hover {
    .swiper-button-prev {
      visibility: visible;
    }
    .swiper-button-next {
      visibility: visible;
    }
  }

  h1 {
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 99;
    font-size: 30px;
    color: #fff;
    top: 30%;
  }
  .banner-btn {
    display: block;
    width: 200px;
    height: 48px;
    background-color: #024c8b;
    text-align: center;
    position: absolute;
    z-index: 99;
    top: 60%;
    left: 50%;
    margin-left: -100px;
    text-align: center;
    line-height: 48px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      background-color: #006fb4;
    }
  }
  .swiper-container {
    font-size: 0;
  }
  .swiper-pagination {
    font-size: 0;
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
    bottom: 22px;
    .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      border-radius: 0;
      background-color: #dddddd;
      opacity: 1;
      border-radius: 50%;
    }
    .swiper-pagination-bullet-active {
      background-color: #db2a4b;
      opacity: 1;
    }
  }

  .swiper-button-prev {
    background-image: none;
    width: 40px;
    height: 40px;
    border: 2px solid #c6191e;
    border-radius: 50%;
    font-size: 20px;
    color: #c6191e;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    left: 30px;
    visibility: hidden;
    i {
      transform: rotate(-90deg);
      font-size: 30px;
      margin-left: -5px;
      font-weight: bold;
    }
  }
  .swiper-button-next {
    background-image: none;
    width: 40px;
    height: 40px;
    border: 2px solid #c6191e;
    border-radius: 50%;
    font-size: 20px;
    color: #c6191e;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    right: 30px;
    visibility: hidden;
    i {
      transform: rotate(90deg);
      font-size: 30px;
      margin-left: -5px;
      font-weight: bold;
    }
  }
}
}
@media (max-width: 799px) {
  
  .swiper-slide {
    width: 100%!important;
  img {
    width: 100%;
  }
}
.gSwiperBox-banner {
  position: relative;
  min-width: 100%;
  padding-top: calc(96vw/7.6);
  &:hover {
    .swiper-button-prev {
      visibility: visible;
    }
    .swiper-button-next {
      visibility: visible;
    }
  }

  h1 {
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 99;
    font-size: 30px;
    color: #fff;
    top: 30%;
  }
  .banner-btn {
    display: block;
    width: 200px;
    height: 48px;
    background-color: #024c8b;
    text-align: center;
    position: absolute;
    z-index: 99;
    top: 60%;
    left: 50%;
    margin-left: -100px;
    text-align: center;
    line-height: 48px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      background-color: #006fb4;
    }
  }
  .swiper-container {
    font-size: 0;
  }
  .swiper-pagination {
    display: none !important;
    font-size: 0;
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
    bottom: 22px;
    .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      border-radius: 0;
      background-color: #dddddd;
      opacity: 1;
      border-radius: 50%;
    }
    .swiper-pagination-bullet-active {
      background-color: #db2a4b;
      opacity: 1;
    }
  }

  .swiper-button-prev {
    display: none !important;
    background-image: none;
    width: 40px;
    height: 40px;
    border: 2px solid #c6191e;
    border-radius: 50%;
    font-size: 20px;
    color: #c6191e;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    left: 30px;
    visibility: hidden;
    i {
      transform: rotate(-90deg);
      font-size: 30px;
      margin-left: -5px;
      font-weight: bold;
    }
  }
  .swiper-button-next {
    display: none !important;
    background-image: none;
    width: 40px;
    height: 40px;
    border: 2px solid #c6191e;
    border-radius: 50%;
    font-size: 20px;
    color: #c6191e;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    right: 30px;
    visibility: hidden;
    i {
      transform: rotate(90deg);
      font-size: 30px;
      margin-left: -5px;
      font-weight: bold;
    }
  }
}
}
</style>